import React from "react";

interface StrategicInsightsProps {
  data: Array<{
    id: number;
    title: string;
    description: string;
    type: string;
  }>;
}

const StrategicInsights: React.FC<StrategicInsightsProps> = ({ data }) => {
  return (
    <div className="bottom-card">
      <div className="si-header">
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" style={{ flexShrink: 0 }}>
          <circle cx="7.5" cy="7.5" r="6.5" stroke="#165697" strokeWidth="1.4"/>
          <path d="M7.5 6.5v4" stroke="#165697" strokeWidth="1.4" strokeLinecap="round"/>
          <circle cx="7.5" cy="4.5" r="0.8" fill="#165697"/>
        </svg>
        <span className="si-header-label">Strategic Insights</span>
      </div>

      <div className="si-list">
        {data.map((insight) => (
          <div key={insight.id} className="si-item">
            <div className="si-item-title">{insight.title}</div>
            <p className="si-item-desc">{insight.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StrategicInsights;
